import React from "react"

import Layout from "components/layout"
import Seo from "components/seo"
import Masthead from "components/masthead"

import JobDescription from "components/jobDescription"

const Position = () => {
  return (
    <Layout dark overlay>
      <Seo
        title="Senior Product Designer"
        description="Help us to improve the lives of 34M workers in financial distress"
      />
      <Masthead title="Senior Product Designer" />
      <article className="wrapper">
        <JobDescription>
          <p>
            We are an early-stage startup{" "}
            <strong>helping employees afflicted by restricted access to credit</strong>. We believe
            we can improve the lives of <strong>thirty-four million workers</strong> by offering{" "}
            <strong>salary advances</strong>, allowing our customers peace of mind in times of need
            through a fair and affordable product. This is a proven business model in the US with
            unicorns like <a href="https://earnin.com/">Earnin</a> and{" "}
            <a href="https://dave.com/">Dave</a>.
          </p>
          <p>
            We are eager to find a Senior Designer responsible for designing the mobile and web
            interfaces that will help improve the lives of Brazilian workers in financial distress.
          </p>

          <h2 className="h3">You are the right person if you:</h2>
          <ul>
            <li>Have worked with UX, UI, or Product Design for 4+ years</li>
            <li>Have startup or design agencies’ experience building products</li>
            <li>Love product discovery and designing scalable interfaces</li>
            <li>
              Also love getting your hands dirty: Doing research, interaction design and analyzing
              how people use products through research methods like usability testing
            </li>
            <li>Believes in strong interaction between business and solving people needs</li>
            <li>Are passionate about creating a world-class user interface</li>
          </ul>
          <h2 className="h3">Location</h2>
          <p>
            We are a remote-first company located in Pinheiros, São Paulo. Due to the pandemic, the
            office will be closed until 2022. Portuguese-speaking designers from anywhere in the
            world can apply.
          </p>
          <h2 className="h3">Benefits</h2>
          <ul>
            <li>Above average compensation</li>
            <li>Generous stock options package</li>
            <li>High quality health care plan including international travel</li>
            <li>Food and transport vouchers</li>
            <li>Access to our high quality savings and loan products</li>
          </ul>
          <p>
            <a href="https://wa.me/5511994555069" className="btn">
              Get in touch with our Head of Design
            </a>
          </p>
        </JobDescription>
      </article>
    </Layout>
  )
}

export default Position
